import type { ComponentPropsWithRef } from 'react';
import Text from '@/storybook/components/Text/Text';
import styles from './Avatar.module.css';
import { TestIds } from './testIds';

export type AvatarSize = 'L' | 'M' | 'S';

export interface AvatarProps extends Omit<ComponentPropsWithRef<'div'>, 'children'> {
  'initials': string;
  'imageUrl'?: string | null;
  'imageAlt'?: string;
  'size'?: AvatarSize;
  'data-testid'?: string;
}

const Avatar = ({
  initials,
  imageUrl,
  imageAlt = '',
  size,
  'data-testid': dataTestId = TestIds.container,
  ...divProps
}: AvatarProps) => (
  <div {...divProps} data-testid={dataTestId}>
    <div className={`${styles.avatar} ${size ? styles[`size${size}`] : ''}`} data-size={size}>
      <div className={styles.container}>
        {imageUrl ? <img src={imageUrl} className={styles.image} alt={imageAlt} /> : <Text as="p">{initials}</Text>}
      </div>
    </div>
  </div>
);

export default Avatar;
